import React from 'react';
import { IEditForm } from '../../types/interfaces/IEditForm';
import { Box, Typography } from '@material-ui/core';
import useStyle from './ReadField.styles';

const ReadField: React.FC<IEditForm> = ({ label, initialValue, valueDisplayHandler }) => {
  const style = useStyle();
  return (
    <Box className={style.container}>
      <Typography variant="subtitle2" className={style.title}>
        {label}
      </Typography>
      {valueDisplayHandler ? (
        valueDisplayHandler(initialValue)
      ) : (
        <Typography variant="subtitle2" className={style.value}>
          {initialValue}
        </Typography>
      )}
    </Box>
  );
};

export default ReadField;
